/* ==========================================================================
   SearcherBustHotel > Client > Loading
   ========================================================================== */

/* Modules */
const prototype = {
    setImage: function Fn(instance) {
        // image Modal
        const cdn = instance.config.image.cdn.replace('//', '');
        const resize = `//${cdn}/${instance.config.image.resize}`;
        const src = instance.config.image.src.replace('##code##', instance.location[1].value);

        return `${resize}${cdn}${src}?jpegQuality=${instance.config.image.quality}`;
    },
    setContentTemplate: function Fn(instance) {
        // Modal Loading
        if (this.modal) {
            const loadingContent = {
                title: instance.loadingData.title,
                description: `${instance.location[1].get().label}
            ${instance.calendar.input.value},
            ${instance.passenger.trigger.value}`,
                message: instance.loadingData.message,
                image: this.setImage(instance)
            };

            this.modal.set(loadingContent);
        }
    }
};

// Exports
module.exports = prototype;
